import type { Command } from '@o2d/history';
import type { BoardState } from '../state/board-state.js';
import type { BoardObject } from '../interfaces/board-object.interface.js';

/**
 * Clone a set of objects as new board entries. The caller supplies fully
 * formed new objects (with fresh ids, slightly offset positions, etc.) so
 * this command stays dumb: it just adds them and removes them on revert.
 */
export class DuplicateObjectsCommand implements Command<BoardState> {
  readonly label: string;

  constructor(private readonly _clones: ReadonlyArray<BoardObject>) {
    this.label = _clones.length === 1 ? 'Objekt duplizieren' : `${_clones.length} Objekte duplizieren`;
  }

  apply(state: BoardState): void {
    for (const clone of this._clones) state.addObject(clone);
  }

  revert(state: BoardState): void {
    for (const clone of this._clones) state.removeObject(clone.id);
  }

  /** The newly created duplicate objects (used by PRD-009 event serializer). */
  get clones(): ReadonlyArray<BoardObject> {
    return this._clones;
  }

  /** The ids of the newly created duplicates (for downstream selection). */
  get cloneIds(): ReadonlyArray<string> {
    return this._clones.map((c) => c.id);
  }
}
